module.exports = __webpack_public_path__ + "static/img/ynzj.3e7fbea0.png";